import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

const BreadCrumbs = () => (
  <Row className='styles-section' id="breadcrumbs">
    <Col sm="12" className='main-page-title'>
      <h3>
        Breadcrumbs
      </h3>
    </Col>

    <div className="home-page-content">
      <Breadcrumb />
      <Breadcrumb path={[{
        link: 'styles',
        title: 'Styles',
      }]} />

      <Breadcrumb path={[{
        link: 'analytics',
        title: 'Offer',
      }, {
        link: 'instagram',
        title: 'Instagram',
      }]} />
      <Breadcrumb autoWire />
    </div>
  </Row>
);

export default React.memo(BreadCrumbs);